import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { STEPS } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Framework = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 75%", "end 60%"] });
  const scale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section id="framework" className="py-24 sm:py-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-8">
          <Reveal className="lg:col-span-7">
            <Eyebrow>Care delivery framework</Eyebrow>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#0B2B26]">
              Five stages. <span className="italic text-[#0E4D44]">No guesswork.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9 self-end">
            <p className="text-base md:text-lg text-[#33504A] leading-relaxed">
              Every patient moves through the same considered sequence — from understanding your concern to tracking progress over time.
            </p>
          </Reveal>
        </div>

        <div ref={ref} data-testid="care-delivery-steps-container" className="relative mt-16 sm:mt-24">
          <div className="absolute left-[19px] lg:left-0 top-0 bottom-0 lg:bottom-auto lg:top-[19px] w-px lg:w-full lg:h-px bg-[#0E4D44]/15" aria-hidden="true" />
          <motion.div style={{ scaleY: scale }} className="lg:hidden absolute left-[19px] top-0 bottom-0 w-px bg-[#D96B43] origin-top" aria-hidden="true" />
          <motion.div style={{ scaleX: scale }} className="hidden lg:block absolute left-0 top-[19px] h-px w-full bg-[#D96B43] origin-left" aria-hidden="true" />
          <ol className="relative grid lg:grid-cols-5 gap-10 lg:gap-6">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08} as="li" className="relative pl-14 lg:pl-0 lg:pt-16">
                <span data-testid={`care-step-${s.n}`} className="absolute left-0 top-0 h-10 w-10 rounded-full bg-[#F6F4EE] border border-[#0E4D44]/25 grid place-items-center font-mono text-xs text-[#0E4D44]">{s.n}</span>
                <h3 className="font-display text-2xl sm:text-3xl tracking-tight text-[#0B2B26]">{s.name}</h3>
                <p className="mt-3 text-sm sm:text-base text-[#33504A] leading-relaxed">{s.desc}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};
